var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "gift-flowers.dd4eb1be.png","uri@2x": __webpack_public_path__ + "gift-flowers.26a7b0bd.png","uri@3x": __webpack_public_path__ + "gift-flowers.90d941f5.png",
    width: 62,
    height: 102
});